<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true">
        <el-form-item label="订单ID">
          <el-input
            v-model="search.orderId"
            type="number"
            placeholder="订单ID"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select
            style="
               {
                width: 200;
              }
            "
            v-model="search.handleStatus"
            multiple
            placeholder="订单状态"
            clearable
          >
            <el-option
              v-for="item in Object.entries(handleStatusMap)"
              :value="item[0]"
              :key="item[0]"
              :label="item[1]"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="酒店">
          <el-select filterable v-model="search.hotel_id" placeholder="选择酒店" clearable>
            <el-option
              v-for="item in hotels"
              :value="item[0]"
              :key="item[0]"
              :label="item[1].tzName || item[1].dltName"
            >
              <span style="float: left">{{ item[1].tzName }}</span>
              <span style="float: right">{{ item[1].dltName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入住日期">
          <el-date-picker
            v-model="search.checkInRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="离店日期">
          <el-date-picker
            v-model="search.checkOutRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="入住人姓名">
          <el-input v-model="search.guestName"></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="search.from" placeholder="选择渠道" clearable>
            <el-option
              :value="1"
              label="同舟"
            >
            </el-option>
            <el-option
              :value="2"
              label="代理通"
            >
            </el-option>
            <el-option
              :value="3"
              label="同程"
            >
            </el-option>
            <el-option
              :value="4"
              label="飞猪"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式" prop="pay" >
          <el-select v-model="search.pay" clearable>
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="search.note"
            placeholder="备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getOrders">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getExcel">导出excel</el-button>
        </el-form-item>
        <!-- <el-form-item v-if="isSuperAdmin">
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>-->
      </el-form>
    </el-col>

    <p>总价格:{{ totalPrice }}, 总利润{{ totalCommission }}, 总间夜数{{ totalRoomCount }} </p>
    <!--列表-->
    <el-table
      :data="orders"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      fixed
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column type="index" width="70"></el-table-column>
      <el-table-column
        prop="from"
        width="70"
        label="渠道"
        :formatter="
          (row) => ( fromMap[row.from])
        "
      ></el-table-column>
      <!-- <el-table-column prop="orderId" label="订单ID"></el-table-column> -->
      <el-table-column
        prop="handleStatus"
        label="处理状态"
        width="100"
        :formatter="(row) => getHandleStatus(row)"
      ></el-table-column>
     

      <el-table-column
        width="150"
        prop="hotel_id"
        label="酒店名"
        :formatter="
          (row) =>
            row.hotel_id
              ? (hotelMap[row.hotel_id] && hotelMap[row.hotel_id][fromNameMap[row.from] || 'tzName']) ||  '-'
              : '-'
        "
      ></el-table-column>
      <el-table-column label="日期,间夜" width="220">
        <template scope="s">
          <p>
            入住日期
            {{ fecha.format(new Date(s.row.checkInDate), "YYYY-MM-DD") }}
          </p>
          <p>
            离店日期
            {{ fecha.format(new Date(s.row.checkOutDate), "YYYY-MM-DD") }}
          </p>
          <p>{{ s.row.stay }}晚</p>
          <p>{{ s.row.roomCount }}间</p>
          <p>早餐 {{ s.row.breakfirst || 0 }} 份</p>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="120">
        <template scope="s">
          <p>价格 {{ s.row.price }}</p>
          <p>原价 {{ s.row.floorPrice }}</p>
          <p>立减 {{ s.row.discount }}</p>
          <p>利润 {{ s.row.commission }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="guestName" label="客户名"></el-table-column>
      <el-table-column prop="goodsName" label="房型"></el-table-column>
      <el-table-column label="结算方式" width="200">
        <template slot-scope="s">
          <p>{{ getPay(s.row) }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注"></el-table-column>
      <el-table-column label="操作" width="200">
        <template scope="scope">
          <!-- <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >-->
          <el-button
            type="danger"
            v-if="!scope.row.handleStatus"
            size="small"
            @click="handleSend(scope.$index, scope.row)"
            >发送</el-button
          >
          <el-button
            size="small"
            v-else
            @click="handleEdit(scope.$index, scope.row)"
            >重新编辑</el-button
          >
          <el-button size="small" type="danger" @click="handleDel(scope.row.id)"
            >删除</el-button
          >

          <!-- <el-button type="text" v-else disabled>{{getHandleStatus(scope.row)}}</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >-->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="20"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="渠道" prop="from">
          <el-select v-model="editForm.from">
            <el-option label="同舟" :value="1" />
            <el-option label="代理通" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="酒店" prop="hotel_id" required>
          <el-select v-model="editForm.hotel_id" class="long-select">
            <el-option
              v-for="(hotel, index) in hotels"
              :key="index"
              :value="+hotel[0]"
              :label="editForm.from == 1 ? hotel[1].tzName : hotel[1].dltName"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="原价" prop="floorPrice" required>
          <el-input type="number" v-model="editForm.floorPrice" placeholder="酒店原价"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price" required>
          <el-input type="number" v-model="editForm.price" placeholder="价格"></el-input>
        </el-form-item>
        <el-form-item label="立减" prop="discount" required>
          <el-input type="number" v-model="editForm.discount" placeholder="立减"></el-input>
        </el-form-item>
        <el-form-item label="房型" prop="goodsName" required>
          <el-input type="text" v-model="editForm.goodsName" placeholder="房型"></el-input>
        </el-form-item>
        <el-form-item label="客人姓名" prop="guestName" required>
          <el-input type="text" v-model="editForm.guestName" placeholder="客人姓名"></el-input>
        </el-form-item>
        <el-form-item label="入住离开日期" required>
          <el-date-picker
            v-model="editForm.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="入住日期"
            end-placeholder="离店日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="房间数" prop="roomCount" required>
          <el-input type="number" v-model="editForm.roomCount" placeholder="房间数"></el-input>
        </el-form-item>
        <el-form-item label="早餐" prop="breakfirst" required>
          <el-input type="number" v-model="editForm.breakfirst" placeholder="早餐"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>-->

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="订单状态" prop="handleStatus">
          <el-select
            v-model="editForm.handleStatus"
            placeholder="订单状态"
            clearable
          >
            <el-option
              v-for="item in Object.entries(handleStatusMap).filter(
                (item) => item[0] != -1
              )"
              :value="item[0]"
              :key="item[0]"
              :label="item[1]"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input
            v-model="editForm.price"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="原价" prop="floorPrice">
          <el-input
            v-model="editForm.floorPrice"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="立减" prop="discount">
          <el-input
            v-model="editForm.discount"
            type="number"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="酒店" prop="hotel_id">
          <el-select filterable v-model="editForm.hotel_id" class="long-select">
            <el-option
              v-for="(hotel, index) in hotels"
              :key="index"
              :value="+hotel[0]"
              :label="hotel[1][fromNameMap[editForm.from]] || hotel[1].tzName"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="send" label="是否发送酒店">
          <el-select v-model="editForm.send">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="早餐" prop="breakfirst" required>
          <el-input
            type="number"
            v-model="editForm.breakfirst"
            placeholder="早餐"
          ></el-input>
        </el-form-item>

        <el-form-item label="结算方式" prop="pay">
          <el-select v-model="editForm.pay">
            <el-option :value="1" label="日结"></el-option>
            <el-option :value="2" label="周结"></el-option>
            <el-option :value="3" label="月结"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" prop="note">
          <el-input v-model="editForm.note" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="用户名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="addForm.role">
            <el-option label="超级管理员" :value="0"></el-option>
            <el-option label="普通管理员" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../common/js/util";
import NProgress from "nprogress";
import { adminApi, hotelApi, orderApi } from "../../api/api";
import { mapGetters } from "vuex";
import fecha from "fecha";
import { tzOrderStatusMap, handleStatusMap,fromMap,fromNameMap } from "../../constant";
import XLSX from "xlsx";
export default {
  data() {
    return {
      fromMap,
      fromNameMap,
      tzOrderStatusMap,
      handleStatusMap,
      stausMap: {},
      hotelMap: {},
      hotels: [],
      search: {
        orderId: "",
        handleStatus: [],
        hotel_id: null,
        checkInRange: [],
        checkOutRange: [],
        guestName: "",
        from: '',
        pay:'',
        note: '',
      },
      totalPrice: 0,
      totalCommission: 0,
      totalRoomCount: 0,
      totalStay: 0,
      orders: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        //   role: [{ required: true, message: '请输入角色', trigger: 'blur' }],
      },
      //编辑界面数据
      // editForm: {
      //   from: 1,
      //   hotel_id: null,
      //   floorPrice: 0,
      //   price: 0,
      //   discount: 0,
      //   checkInDate: "",
      //   checkOutDate: "",
      //   guestName: "",
      //   goodsName: "",
      //   stay: 1,
      //   roomCount: 1,
      //   breakfirst: 0
      // },
      editForm: {
        note: "",
        discount: 0,
        floorPrice: 0,
        price: 0,
        id: "",
        hotel_id: "",
        handleStatus: "1",
        send: 1,
        breakfist: 0,
        pay: ''
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        name: "",
        password: "",
        role: 1,
      },
    };
  },
  methods: {
    //性别显示转换
    formatRole: function (row, column) {
      return row.role == 0 ? "超级管理员" : "普通管理员";
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOrders();
    },
    getExcel() {
      this.getOrders(1);
    },
    //获取用户列表
    getOrders(all = 0) {
      let para = {
        page: this.page,
        search: this.search,
        all,
      };
      this.listLoading = true;
      NProgress.start();
      orderApi.list(para).then((res) => {
        res.data.rows.forEach((row) => {
          row.price = row.price / 100;
          row.floorPrice = row.floorPrice / 100;
          row.discount = row.discount / 100;
          row.commission = row.commission / 100;
        });
        if (all != "1") {
          this.total = res.data.count;
          this.orders = res.data.rows;
          this.totalPrice = res.data.totalPrice / 100;
          this.totalCommission = res.data.totalCommission / 100;
          this.totalStay = res.data.totalStay;
          this.totalRoomCount = res.data.totalRoomCount;
        } else {
          const firstLine = [
            "客户名",
            "房型",
            "入住日期",
            "离店日期",
            "晚",
            "间",
            "价格",
            "原价",
            "立减",
            "利润",
            "渠道",
            "处理状态",
            "酒店名",
            "备注",
          ];
          const datas = res.data.rows.map(
            ({
              checkInDate,
              checkOutDate,
              goodsName,
              guestName,
              stay,
              roomCount,
              price,
              floorPrice,
              discount,
              commission,
              from,
              handleStatus,
              hotel_id,
              note,
              orderId,
            }) => {
              console.log("orderid", orderId);
              return [
                guestName,
                goodsName,
                fecha.format(new Date(checkInDate), "YYYY-MM-DD"),
                fecha.format(new Date(checkOutDate), "YYYY-MM-DD"),
                stay,
                roomCount,
                price,
                floorPrice,
                discount,
                commission,
                from == 1 ? "同舟" : "代理通",
                !!handleStatus
                  ? handleStatusMap[handleStatus] || "未处理"
                  : "未处理",
                from == 1
                  ? (this.hotelMap[hotel_id] &&
                      this.hotelMap[hotel_id].tzName) ||
                    "-"
                  : (this.hotelMap[hotel_id] &&
                      this.hotelMap[hotel_id].dltName) ||
                    "-",

                "",
              ];
            }
          );
          var filename = `订单.xlsx`; //文件名称
          var data = [firstLine, ...datas];
          var ws_name = "Sheet1";
          var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.aoa_to_sheet(data);
          XLSX.utils.book_append_sheet(wb, ws, ws_name); //将数据添加到工作薄
          XLSX.writeFile(wb, filename); //导出Excel
        }
        NProgress.done();
        this.listLoading = false;
      });
    },
    getOrderStatus(row) {
      const map = row.from == 1 ? tzOrderStatusMap : {};
      return map[row.orderStatus] || row.orderStatus;
    },
    getHandleStatus(row) {
      return !!row.handleStatus
        ? handleStatusMap[row.handleStatus] || "未处理"
        : "未处理";
    },
    getSettleStatus(row) {
      if (!row.settle) {
        return "未提出申请";
      }
      switch (row.settle) {
        case 1:
          return "已提出结算申请，等待处理";
        case 2:
          return "已处理";
      }
    },
    getPay(row){
      const e  = {
        1: '日结',
        2: '周结',
        3: '月结'
      }
      return e[row.pay] || '-'
    },
    getSettleTime(row) {
      if (!row.settleTime) return "-";
      return fecha.format(new Date(row.settleTime), "YYYY-MM-DD");
    },
    //删除
    handleSend: function (index, row) {
      NProgress.start();
      if (!row.hotel_id) {
        return this.$message.error("请先设置该订单的酒店");
      }
      if (!row.price) {
        return this.$message.error("请先设置该订单价格");
      }
      let para = { id: row.id };
      orderApi
        .send(para)
        .then((res) => {
          this.listLoading = false;
          NProgress.done();
          this.$message({
            message: "发送成功",
            type: "success",
          });
        })
        .finally((_) => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      console.log(Object.entries(handleStatusMap), row);
      this.editForm = Object.assign(this.editForm, row);
      this.editForm.handleStatus = `${this.editForm.handleStatus}`;
    },
    handleDel(id) {
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        orderApi.delete(id).then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.getOrders();
        });
      });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (!this.editForm.price) {
            return this.$message.error("请设置订单价格");
          }
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.editLoading = true;
              //NProgress.start();
              let para = Object.assign({}, this.editForm);
              if (!para.price) {
                return this.$message.error("请先设置该订单价格");
              }

              orderApi.update(para).then((res) => {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                // this.handleSend(0, para);
                this.getOrders();
              });
            })
            .finally((_) => {
              this.editLoading = false;
            });
        }
      });
    },
    //新增
    addSubmit: function () {
      console.log(this.addForm);
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            //   para.birth =
            //     !para.birth || para.birth == ''
            //       ? ''
            //       : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            adminApi.add(para).then((res) => {
              this.addLoading = false;
              //NProgress.done();
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getOrders();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      var ids = this.sels.map((item) => item.id).toString();
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };
          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getOrders();
          });
        })
        .catch(() => {});
    },
    getHotelMap() {
      hotelApi.listMap().then(({ data }) => {
        this.hotelMap = data;
        this.hotels = Object.entries(data);
        window.vm = this;
      });
    },
  },
  created() {
    this.fecha = fecha;
  },
  mounted() {
    this.getHotelMap();
    this.getOrders();
  },
  computed: {
    ...mapGetters(["getUserInfo", "isSuperAdmin"]),
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?5f1dbdf9